import { render, staticRenderFns } from "./SysLogList.vue?vue&type=template&id=1c70a9b5&scoped=true&"
import script from "./SysLogList.vue?vue&type=script&lang=js&"
export * from "./SysLogList.vue?vue&type=script&lang=js&"
import style0 from "./SysLogList.vue?vue&type=style&index=0&id=1c70a9b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70a9b5",
  null
  
)

export default component.exports